"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
Object.defineProperty(exports, "__esModule", { value: true });
exports.Category = void 0;
const flatbuffers = require("flatbuffers");
const sb_type_js_1 = require("../../sportsbook/tree/sb-type.js");
class Category {
    bb = null;
    bb_pos = 0;
    __init(i, bb) {
        this.bb_pos = i;
        this.bb = bb;
        return this;
    }
    static getRootAsCategory(bb, obj) {
        return (obj || new Category()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    static getSizePrefixedRootAsCategory(bb, obj) {
        bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
        return (obj || new Category()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    sbId() {
        const offset = this.bb.__offset(this.bb_pos, 4);
        return offset ? this.bb.readUint32(this.bb_pos + offset) : 0;
    }
    customId() {
        const offset = this.bb.__offset(this.bb_pos, 6);
        return offset ? this.bb.readUint32(this.bb_pos + offset) : 0;
    }
    name(optionalEncoding) {
        const offset = this.bb.__offset(this.bb_pos, 8);
        return offset ? this.bb.__string(this.bb_pos + offset, optionalEncoding) : null;
    }
    state() {
        const offset = this.bb.__offset(this.bb_pos, 10);
        return offset ? this.bb.readInt8(this.bb_pos + offset) : 1;
    }
    weight() {
        const offset = this.bb.__offset(this.bb_pos, 12);
        return offset ? this.bb.readInt8(this.bb_pos + offset) : 0;
    }
    sbSportId() {
        const offset = this.bb.__offset(this.bb_pos, 14);
        return offset ? this.bb.readUint32(this.bb_pos + offset) : 0;
    }
    customSportId() {
        const offset = this.bb.__offset(this.bb_pos, 16);
        return offset ? this.bb.readUint32(this.bb_pos + offset) : 0;
    }
    countryCode(optionalEncoding) {
        const offset = this.bb.__offset(this.bb_pos, 18);
        return offset ? this.bb.__string(this.bb_pos + offset, optionalEncoding) : null;
    }
    sportEventsNumber() {
        const offset = this.bb.__offset(this.bb_pos, 20);
        return offset ? this.bb.readUint16(this.bb_pos + offset) : 0;
    }
    liveSportEventsNumber() {
        const offset = this.bb.__offset(this.bb_pos, 22);
        return offset ? this.bb.readUint16(this.bb_pos + offset) : 0;
    }
    sbType() {
        const offset = this.bb.__offset(this.bb_pos, 24);
        return offset ? this.bb.readInt8(this.bb_pos + offset) : sb_type_js_1.SbType.category;
    }
    static startCategory(builder) {
        builder.startObject(11);
    }
    static addSbId(builder, sbId) {
        builder.addFieldInt32(0, sbId, 0);
    }
    static addCustomId(builder, customId) {
        builder.addFieldInt32(1, customId, 0);
    }
    static addName(builder, nameOffset) {
        builder.addFieldOffset(2, nameOffset, 0);
    }
    static addState(builder, state) {
        builder.addFieldInt8(3, state, 1);
    }
    static addWeight(builder, weight) {
        builder.addFieldInt8(4, weight, 0);
    }
    static addSbSportId(builder, sbSportId) {
        builder.addFieldInt32(5, sbSportId, 0);
    }
    static addCustomSportId(builder, customSportId) {
        builder.addFieldInt32(6, customSportId, 0);
    }
    static addCountryCode(builder, countryCodeOffset) {
        builder.addFieldOffset(7, countryCodeOffset, 0);
    }
    static addSportEventsNumber(builder, sportEventsNumber) {
        builder.addFieldInt16(8, sportEventsNumber, 0);
    }
    static addLiveSportEventsNumber(builder, liveSportEventsNumber) {
        builder.addFieldInt16(9, liveSportEventsNumber, 0);
    }
    static addSbType(builder, sbType) {
        builder.addFieldInt8(10, sbType, sb_type_js_1.SbType.category);
    }
    static endCategory(builder) {
        const offset = builder.endObject();
        return offset;
    }
    static createCategory(builder, sbId, customId, nameOffset, state, weight, sbSportId, customSportId, countryCodeOffset, sportEventsNumber, liveSportEventsNumber, sbType) {
        Category.startCategory(builder);
        Category.addSbId(builder, sbId);
        Category.addCustomId(builder, customId);
        Category.addName(builder, nameOffset);
        Category.addState(builder, state);
        Category.addWeight(builder, weight);
        Category.addSbSportId(builder, sbSportId);
        Category.addCustomSportId(builder, customSportId);
        Category.addCountryCode(builder, countryCodeOffset);
        Category.addSportEventsNumber(builder, sportEventsNumber);
        Category.addLiveSportEventsNumber(builder, liveSportEventsNumber);
        Category.addSbType(builder, sbType);
        return Category.endCategory(builder);
    }
}
exports.Category = Category;
